module.exports = __webpack_public_path__ + "img/34.f40d2f3e.jpg";